import axios from 'axios';
import { api } from '@/lib';

export async function getUsuariosInstancia(tipoUsuario: string) {
  try {
    const instanciaUsuario = await api.get('/usuario/Usuario-Instancias', {
      params: {
        tipoUsuario: tipoUsuario,
      },
    });
    return instanciaUsuario.data.data;
  } catch (err) {
    let message = 'Ocorreu um erro ao buscar dados do paciente';

    if (axios.isAxiosError(err)) {
      message = err?.response?.data?.errors?.[0] || message;
    }

    console.log({
      title: message,
      status: 'error',
    });

    throw err;
  }
}
